module.exports = __webpack_public_path__ + "static/media/eventIcon.264acdfa.png";